import { CloseButton, Modal } from 'react-bootstrap'
import { redirect } from 'next/navigation'
import {
    useGetImagesProductMutation,
    useGetOtherProductsMutation,
    useGetProductCatalogMutation,
    useGetQuestionsProductMutation,
    useGetReviewsProductMutation,
} from '@/shared/api-rtk/index.js'
import { useGetCartItemsQuery } from '@/shared/api-rtk'
import { useEffect, useState, useMemo } from 'react'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'
import { useCutLengthText } from '@/shared/hooks/useCutLengthText.js'
import { useAddProductToCartMutation } from '@/shared/api-rtk/api-list/cartApi'
import { useDispatch } from 'react-redux'
import { changeCountItems } from '@/shared/store/slice/cartSlice'
import { toast } from 'react-toastify'
import { IMAGE_DIR } from '@/shared/constants/linksApi'
import ReviewCard from '@/entities/ReviewCard/index.js'
import QuestionItem from '@/entities/questions-page/QuestionItem/index.js'
import { RecommendedProduct } from '@/entities/ModalQuickView/ui/RecommendedProduct/index.jsx'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'
import './ModalQuickView.css'

// ✅ Swiper импорты
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Navigation, Thumbs } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'

const sectionModal = ['Описание']

export const ModalQuickView = ({ show, onHide, productId, item }) => {
    const { data: productsInCart } = useGetCartItemsQuery()
    const cert = item?.name == 'Подарочный сертификат'
    const { userInfo, userAuth } = useGetIsAuthUser()
    const navigate = (path) => redirect(path)
    const [showSection, setShowSection] = useState(sectionModal[0])
    const [imagesProduct, setImagesProduct] = useState([])
    const [aboutProduct, setAboutProduct] = useState(null)
    const [otherProducts, setOtherProducts] = useState(null)
    const [reviews, setReviews] = useState([])
    const [questions, setQuestions] = useState([])

    // ✅ Swiper thumbs
    const [thumbsSwiper, setThumbsSwiper] = useState(null)

    const dispatch = useDispatch()
    const [addProductToCart] = useAddProductToCartMutation()
    const [getImages] = useGetImagesProductMutation()
    const [getProduct] = useGetProductCatalogMutation()
    const [getRecommended] = useGetOtherProductsMutation()
    const [getReviews] = useGetReviewsProductMutation()
    const [getFaq] = useGetQuestionsProductMutation()

    const addItemCart = async () => {
        if (
            (productsInCart?.data.length > 0 && cert) ||
            (productsInCart.data?.includes('187') && !cert)
        ) {
            toast.warn(
                'Вы можете одновременно заказать либо один Сертификат либо продукцию на нашем сайте.'
            )
        } else {
            try {
                const result = await addProductToCart({
                    product_id: productId,
                    quantity: 1,
                })
                const data = result.data
                if (!data.success) return
                const total = parseInt(data.total.split(' ')[1])
                dispatch(changeCountItems(total))
                toast.success(data.total)
            } catch (error) {}
        }
    }

    const aboutText =
        aboutProduct &&
        useCutLengthText(aboutProduct[0].description_no_html, 350)

    useEffect(() => {
        getFaq(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setQuestions(Object.values(res.data))
                } else {
                    setQuestions([])
                }
            })
        getReviews(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setReviews(Object.values(res.data))
                }
            })
        getImages(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setImagesProduct(Object.values(res.data))
                }
            })
        getProduct(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setAboutProduct(Object.values(res.data))
                }
            })
            .catch(() => {
                TOAST_ERROR('Не удалось получить информацию о товаре')
                onHide()
            })
        getRecommended(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setOtherProducts(Object.values(res.data))
                }
            })
    }, [])

    if (!aboutProduct) return null

    const toggleSection = (section, url) => {
        if (showSection === section) {
            navigate('/' + url)
            return
        }
        setShowSection(section)
    }

    const getDiscountPrice = (specials) => {
        const userGroup = userAuth ? Number(userInfo.customerGroupId) : 0
        let special = null
        const specialsData = Object.values(specials)
        for (let element of specialsData) {
            const groupId = Number(element.customer_group_id)
            if (
                (groupId === 1 && userGroup !== 2) ||
                (groupId === 2 && userGroup === 2)
            ) {
                special = element
            }
        }
        return special ? special.price : false
    }

    // ✅ собираем массив слайдов: сначала item.image, потом imagesProduct
    const allImages = []
    if (item?.image) allImages.push({ image: item.image, fromItem: true })
    if (imagesProduct?.length) allImages.push(...imagesProduct)

    return (
        <Modal
            size="xl"
            show={show}
            onHide={onHide}
            className={'ModalQuickView'}
        >
            <Modal.Header className={'content'}>
                {/* ✅ Если одна картинка — показываем просто <img /> */}
                {allImages.length <= 1 ? (
                    <img
                        src={
                            allImages.length
                                ? IMAGE_DIR + allImages[0].image
                                : IMAGE_DIR + aboutProduct[0]?.image
                        }
                        alt="product"
                        className="single-image"
                    />
                ) : (
                    <div className="carousel-container">
                        {/* Основной слайдер */}
                        <Swiper
                            spaceBetween={10}
                            navigation={true}
                            thumbs={{ swiper: thumbsSwiper }}
                            modules={[FreeMode, Navigation, Thumbs]}
                            className="main-swiper"
                        >
                            {allImages.map((img, idx) => (
                                <SwiperSlide key={idx}>
                                    <img
                                        src={IMAGE_DIR + img.image}
                                        alt="product"
                                        className="carousel-image"
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>

                        {/* Thumbs */}
                        <Swiper
                            onSwiper={setThumbsSwiper}
                            spaceBetween={10}
                            slidesPerView={4}
                            freeMode={true}
                            watchSlidesProgress={true}
                            modules={[FreeMode, Navigation, Thumbs]}
                            className="thumbs-swiper"
                        >
                            {allImages.map((img, idx) => (
                                <SwiperSlide key={idx}>
                                    <img
                                        src={IMAGE_DIR + img.image}
                                        alt="thumb"
                                        className="thumb-image"
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                )}

                <div className={'product'}>
                    <div className={'actions-header'}>
                        <CloseButton
                            style={{
                                borderRadius: '0.5rem',
                                backgroundColor: '#e3e3e3',
                            }}
                            onClick={onHide}
                        />
                    </div>
                    <div className={'product-text'}>
                        <h3 onClick={() => navigate(`/${aboutProduct[0].url}`)}>
                            {aboutProduct[0].name}
                        </h3>
                        <div className={'subtitle'}>
                            {aboutProduct[0].sku && (
                                <span>{aboutProduct[0].sku}</span>
                            )}
                            <div className={'actions'}>
                                <button
                                    className={
                                        showSection === sectionModal[0]
                                            ? 'btn-disabled'
                                            : ''
                                    }
                                    onClick={() =>
                                        toggleSection(
                                            sectionModal[0],
                                            aboutProduct[0].url
                                        )
                                    }
                                >
                                    Описание
                                </button>
                            </div>
                        </div>
                        {showSection === sectionModal[0] && (
                            <p className={'about-text'}>{aboutText}</p>
                        )}
                    </div>

                    <div className={'product-price'}>
                        <div className={'price'}>
                            <h2>
                                {parseInt(
                                    aboutProduct[0].price
                                ).toLocaleString()}{' '}
                                ₽
                            </h2>
                            {getDiscountPrice(aboutProduct[0].specials) && (
                                <span>
                                    {parseInt(
                                        getDiscountPrice(
                                            aboutProduct[0].specials
                                        )
                                    ).toLocaleString()}{' '}
                                    ₽
                                </span>
                            )}
                        </div>
                        {Number(item?.quantity) > 0 ? (
                            <button onClick={addItemCart}>В корзину</button>
                        ) : (
                            <button disabled={true}>Нет в наличии</button>
                        )}
                    </div>

                    {otherProducts && (
                        <div className={'product-rec'}>
                            <h5>Рекомендуемые товары</h5>
                            <div className={'products'}>
                                {otherProducts
                                    .slice(0, 3)
                                    .map((otherProduct, index) => (
                                        <RecommendedProduct
                                            key={index}
                                            price={otherProduct.price}
                                            title={otherProduct.name}
                                            imageLink={
                                                IMAGE_DIR + otherProduct.image
                                            }
                                            linkToProduct={
                                                '/' + otherProduct.url
                                            }
                                        />
                                    ))}
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Header>
        </Modal>
    )
}
